export const KarmaPoolDonationProofManager = (local, setLocal, parentRefresh, getURLBasePath) => {

    function getCause(causeName) {
        for (let i = 0; i < local.causes.length; i++) {
            const c = local.causes[i];

            if (c["name"] === causeName) {
                return c;
            }
        }

        return {};
    }

    function fetchLatestDonationProof() {
        fetch(getURLBasePath() + 'donationProof', {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setLocal(prevValue => {
                    return { ...prevValue, donationProofs: data };
                });
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    return {
        fetchLatestDonationProof
    };
}